import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, TextField, Typography, Box } from '@material-ui/core';
import { Field, reduxForm } from 'redux-form';
import { isMobile } from 'react-device-detect';
// import { useTheme } from '@material-ui/core';
// Función de validación para Redux-Form
const validate = (values) => {
    const errors = {};
    if (!values.observation) {
        errors.observation = 'Este campo es requerido.';
    }
    return errors;
};

// Renderiza un TextField compatible con Redux-Form
const renderTextField = ({ input, label, meta: { touched, error } }) => (
    <TextField
        {...input}
        label={label}
        error={touched && !!error}
        helperText={touched && error ? error : ' '}
        fullWidth
        size={isMobile ? 'small' : 'medium'}
        autoComplete="off"
    />
);

const SendValidationPayrollForm = ({ handleSubmit, children, dataTotal, validator, onSubmit }) => {
    //console.log('validator',validator)
    const handleApprove = (data) => onSubmit(data, 'approve');
    const handleReject = (data) => onSubmit(data, 'reject');
    
    return (
        <form onSubmit={handleSubmit} autoComplete="off" style={{ paddingInline: '1rem' }}>
            <Grid container spacing={2} justifyContent="space-evenly" direction="column">
                <Grid item xs={12} style={{ paddingBottom: 3, paddingTop: 2 }}>
                    <Box flex={1} flexWrap='wrap' flexDirection='column' style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px', borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                        <Typography component="span" style={{ fontWeight: 'bold', color: 'black', marginLeft: '12px' }}>
                            Total: $
                        </Typography>
                        <Typography component="span" style={{ fontWeight: 'bold', marginLeft: 0.5 }}>
                            {dataTotal}
                        </Typography>
                    </Box>
                </Grid>
                {(validator && validator.state === 1) &&

                    <Grid item xs={12} style={{ paddingBottom: 3, paddingTop: 2 }}>
                        <Field name="observation" component={renderTextField} label="Observación" />
                    </Grid>
                }
                <Grid item xs={12}>
                    {children}
                </Grid>

                <br />
                <Grid container justifyContent="space-evenly">
                    {(validator && validator.state === 1) &&
                        <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', padding: '20px 40px' }}>
                            <Button
                                variant="outlined"
                                color='primary'
                                style={{ padding: '6px 20px', borderRadius: { xs: '15px', md: '5px' }, fontSize: { xs: '.75rem', sm: '1rem' } }}
                                onClick={handleSubmit(handleReject)}
                            >
                                RECHAZAR
                            </Button>
                            <Button color="secondary" variant="contained" onClick={handleSubmit(handleApprove)} style={{ padding: '6px 20px' }}>
                                APROBAR
                            </Button>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </form>
    );
};

SendValidationPayrollForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    dataTotal: PropTypes.number.isRequired,
    validator: PropTypes.object.isRequired,
};

// Conectamos el formulario a Redux
export default reduxForm({
    form: 'sendValidationPayrollForm',
    validate,
})(SendValidationPayrollForm);
